// removed by extract-text-webpack-plugin
module.exports = {"baseBlack":"_3sim3","appsWrapper":"u85Tj","epicHeaderWrapper":"_36BTK","epicLogoWrapper":"_3h7Of","epicHeaderImg":"_2e8JT","header":"b5dAH","headerDesc":"_2_FIe","base":"_2FEc2","src-components-layout-Grid-Container-Container---container---TLZC7":"_1q7bv","epicTilesWrapper":"_26Iz-","sectionTitle":"bhKcc","archive":"_3A0Xx","archiveText":"_3wqK-","callToAction":"_1gpTF","headingWrapper":"QWfEY","getHelpWrapper":"_1IzTH","helpText":"mKvFY","linkButton":"_1ffHV"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/Home.scss
// module id = 1623
// module chunks = 0